import { useLang } from "../context/LanguageContext";
import "./ProcessTimeline.css";

const icons = [
  "/images/icons/sign.png",
  "/images/icons/wood.png",
  "/images/icons/craft.png",
];

export default function ProcessTimeline() {
  const { t } = useLang();
  return (
    <section className="process-section section">
      <div className="section-inner">
        <h2 className="section-title fade-in">{t.project.title}</h2>
        <p className="section-subtitle fade-in fade-in-delay-1">{t.project.subtitle}</p>
        <div className="gold-line" />
        <div className="timeline fade-in fade-in-delay-2">
          {t.project.steps.map((step, i) => (
            <div key={i} className="timeline-step">
              <div className="timeline-icon-wrap">
                <img src={icons[i]} alt={step} className="timeline-icon-img" />
              </div>
              {i < t.project.steps.length - 1 && <div className="timeline-line" />}
              <div className="timeline-label">{step}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
